import { Component } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'

@Component({
  selector: 'app-bwc-vehicle-data',
  templateUrl: './bwc-vehicle-data.component.html',
  standalone: false,
})
export class BwcVehicleDataComponent {
  public layerIds = Layers
  public isProvider4HeavyRainLayerVisible: boolean | undefined
  public isProvider4FogLayerVisible: boolean | undefined

  constructor(private appState: AppStateService) {
    const layers = this.appState.getState().layers
    this.isProvider4FogLayerVisible = layers?.includes(Layers.Provider4Fog.name)
    this.isProvider4HeavyRainLayerVisible = layers?.includes(Layers.Provider4HeavyRain.name)
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider4Fog.name:
        this.isProvider4FogLayerVisible = !this.isProvider4FogLayerVisible
        break
      case Layers.Provider4HeavyRain.name:
        this.isProvider4HeavyRainLayerVisible = !this.isProvider4HeavyRainLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !layer.includes(Layers.Provider4Fog.name) &&
          !layer.includes(Layers.Provider4HeavyRain.name) &&
          !layer.includes(Layers.Provider4Slippery.name),
      )

    if (this.isProvider4FogLayerVisible) {
      layers.push(Layers.Provider4Fog.name)
    }
    if (this.isProvider4HeavyRainLayerVisible) {
      layers.push(Layers.Provider4HeavyRain.name)
    }

    this.appState.setState(AppPaths.BadWeatherCondition, {
      layers: layers?.toString(),
    })
  }
}
